import LogoutIcon from '@mui/icons-material/Logout';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import React, { PropsWithChildren } from 'react';

import { logout } from '@/api/util/logoutRequest.util.ts';
import { useGetEnv } from '@/api/util/useGetEnv.util.ts';
import { BackgroundBranding } from '@/layouts/private/background/BackgroundBranding.comp.tsx';
import {
  getLayoutContainerStyles,
  LAYOUT_CONTENT_ID,
  LayoutMainStyles,
  LayoutShellStyles,
  LayoutStyles,
} from '@/layouts/private/Layout.styles.ts';
import { Logo } from '@/layouts/private/logo/Logo.comp.tsx';
import { CvSearchSyncStatus } from '@/layouts/private/topBar/components/cvSearchSyncStatus/CvSearchSyncStatus.comp.tsx';
import { EnvironmentBanner } from '@/layouts/private/topBar/components/EnvironmentBanner.comp.tsx';
import TopMenuTabs from '@/layouts/private/topBar/components/TopMenuTabs.comp.tsx';
import TopBarNavigation from '@/layouts/private/topBar/TopBarNavigation.comp.tsx';
import { PATHS_WITHOUT_SESSION } from '@/routes/RoutesNotRequiringAuth.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { env } = useGetEnv();
  const { t } = useTranslationWithPrefix('layouts');
  const hasEnvironmentBanner = env?.env === 'dev' || env?.env === 'preview';

  const handleLogout = async () => {
    await logout();
  };

  if (PATHS_WITHOUT_SESSION) {
    return (
      <>
        <CssBaseline />
        {children}
      </>
    );
  }

  return (
    <Stack sx={LayoutStyles}>
      <CssBaseline />
      <BackgroundBranding />
      <Stack sx={LayoutShellStyles}>
        <EnvironmentBanner />
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Stack
            direction="row"
            spacing={5}
            sx={{
              alignItems: 'center',
            }}
          >
            <TopBarNavigation>
              <Logo />
              <TopMenuTabs />
            </TopBarNavigation>
          </Stack>
          <Stack direction="row" sx={{ alignItems: 'center', mr: 3 }}>
            <CvSearchSyncStatus />
            <IconButton onClick={handleLogout}>
              <Tooltip title={t('logout.tooltip')}>
                <LogoutIcon />
              </Tooltip>
            </IconButton>
          </Stack>
        </Stack>
        <Box id={LAYOUT_CONTENT_ID} sx={getLayoutContainerStyles(hasEnvironmentBanner)}>
          <Stack direction="row" sx={LayoutMainStyles}>
            {children}
          </Stack>
          {/* <Footer />*/}
        </Box>
      </Stack>
    </Stack>
  );
};

export default Layout;
